import { t } from "@lingui/core/macro";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { MembershipDetailScreen } from "@/screens/Profile/screens/MembershipDetailScreen";
import { MembershipListScreen } from "@/screens/Profile/screens/MembershipListScreen";
import { MembershipOrderScreen } from "@/screens/Profile/screens/MembershipOrderScreen";

export type MembershipsStackNavigatorParamList = {
  MembershipsList: undefined;
  MembershipDetail: { membershipId: string };
  MembershipOrder: { orderId: string; membershipId: string };
};

const Stack = createNativeStackNavigator<MembershipsStackNavigatorParamList>();

export const MembershipsStackNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="MembershipsList"
      screenOptions={(screenProps) => ({
        headerShown: false,
      })}
    >
      <Stack.Screen
        name="MembershipsList"
        options={{
          title: t`Memberships`,
        }}
        component={MembershipListScreen}
      />
      <Stack.Screen
        name="MembershipDetail"
        options={{
          title: t`Memberships`,
        }}
        component={MembershipDetailScreen}
      />
      <Stack.Screen
        name="MembershipOrder"
        options={{
          title: t`Memberships`,
        }}
        component={MembershipOrderScreen}
      />
    </Stack.Navigator>
  );
};
